export const TicketStatus = {
    Registered: 'Registered',
    Won: 'Won',
    Lost: 'Lost',
    PaidOut: 'PaidOut',
    Cancelled: 'Cancelled'
};

export const TicketWinningMethod = {
    Normal: 'Normal',
    ReturnedBet: 'ReturnedBet',
    CancelledBet: 'CancelledBet',
    BonusGame: 'BonusGame',
    Cashin: 'Cashin'
};

export const TicketDisplayStatus = {
    Registered: 'Registered',
    Won: 'Won',
    Lost: 'Lost',
    PaidOut: 'PaidOut',
    Cancelled: 'Cancelled',
    CashinPaidOut: 'CashinPaidOut',
    ReturnPaidOut: 'ReturnPaidOut',
    ReturnWon: 'ReturnWon'
};

export const CashinOfferStatus = {
    NotAvailable: 'NotAvailable',
    Running: 'Running',
    InProgress: 'InProgress',
    Finished: 'Finished',
    Stopped: 'Stopped'
};

export const TicketSource = {
    Placed: 'Placed',
    Saved: 'Saved'
};

export const ExtraType = {
    freeTicket: 'freeTicket',
    oddsAdvantage: 'oddsAdvantage',
    automaticOddsAdvantage: 'automaticOddsAdvantage'
};

export const BetslipTicketsTabs = {
    savedTickets: 'my-saved-tickets',
    currentTickets: 'my-current-tickets',
    allTickets: 'my-all-tickets',
    cashinTickets: 'my-cashin-tickets'
};

export const PickState = {
    RUNNING: 'RUNNING',
    FINISHED: 'FINISHED',
    UNAVAILABLE: 'UNAVAILABLE',
    TRANSACTION_ACTIVE: 'TRANSACTION_ACTIVE'
};

export const CashinTransactionStatus = {
    Started: 'Started',
    Activated: 'Activated',
    AuthorizationRequired: 'AuthorizationRequired',
    Approved: 'Approved',
    Rejected: 'Rejected'
};

export const ModificationState = {
    UNMODIFIED: 'UNMODIFIED',
    CLOSED: 'CLOSED'
};

export const EvaluationState = {
    REGISTERED: 'REGISTERED',
    WON: 'WON',
    LOST: 'LOST',
    RETURNED: 'RETURNED',
    CANCELLED: 'CANCELLED'
};

export const CustomerChangeApproval = {
    ALL: 'ALL',
    NONE: 'NONE',
    ONLY_HIGHER: 'ONLY_HIGHER'
};
